const isUrclyrd = (process.env.REACT_APP_VARIANT || '').toUpperCase() === 'URCLYRD';

export default {
  Email: 'E-mail',
  Password: 'Mot de passe',
  Login: 'Connexion',
  "You don't have an account?": "Vous n'avez pas de compte ?",
  'Register here': 'Inscrivez-vous ici',
  Role: 'Rôle',
  Name: 'Prénom',
  Save: 'Enregistrer',
  Surname: 'Nom de famille',
  'Confirm password': 'Confirmer le mot de passe',
  Register: "S'inscrire",
  'Already have an account?': 'Vous avez déjà un compte ?',
  'sign in': 'se connecter',
  'My profile': 'Mon profil',
  Logout: 'Déconnexion',
  'Change password': 'Changer le mot de passe',
  'Your profile picture was updated': 'Votre photo de profil a été mise à jour',
  'Your profile information was updated': 'Vos informations de profil ont été mises à jour',
  'New password': 'Nouveau mot de passe',
  'Confirm new password': 'Confirmer le nouveau mot de passe',
  'Your password has been changed': 'Votre mot de passe a été changé',
  Cancel: 'Annuler',
  'Update information': 'Mettre à jour les informations',
  'Upload new picture': 'Télécharger une nouvelle photo',
  'Pending invitations for today': "Invitations en attente pour aujourd'hui",
  'There are no pending invitations for today':
    "Il n'y a pas d'invitations en attente pour aujourd'hui",
  'My buildings': 'Mes immeubles',
  'My invitations': 'Mes invitations',
  'No buildings were found': 'Aucun immeuble trouvé',
  Home: 'Accueil',
  'Building detail': "Détail de l'immeuble",
  Address: 'Adresse',
  Manager: 'Gestionnaire',
  'My user roles in this building': "Mes rôles d'utilisateur dans cet immeuble",
  COMPANY_SECRETARY: "Secrétaire d'entreprise",
  BUILDING_MANAGER: "Gestionnaire d'immeuble",
  'BUILDING_MANAGER.description':
    "Permission de gérer les informations de l'immeuble et les utilisateurs, les entreprises, d'accéder à l'immeuble et de créer des invitations d'accès",
  COMPANY_MANAGER: "Gestionnaire d'entreprise",
  'COMPANY_MANAGER.description':
    "Permission de gérer les informations de l'entreprise et les utilisateurs, d'accéder à l'immeuble et de créer des invitations d'accès",
  EMPLOYEE: "Personnel de l'immeuble",
  'EMPLOYEE.description': "Permission d'accéder à l'immeuble",
  HOST_EMPLOYEE: "Personnel de l'immeuble avec permissions d'hôte",
  'HOST_EMPLOYEE.description':
    "Permission d'accéder à l'immeuble et de créer des invitations d'accès",
  SECURITY: "Personnel de sécurité de l'immeuble",
  'SECURITY.description':
    "Permission d'accéder à l'immeuble, de créer des invitations et d'autoriser l'accès à d'autres utilisateurs",
  Edit: 'Modifier',
  'Manage companies': 'Gérer les entreprises',
  'No records found': 'Aucun enregistrement trouvé',
  'My roles': 'Mes rôles',
  'Manage users': 'Gérer les utilisateurs',
  Detail: 'Détail',
  'The building information has been updated':
    "Les informations de l'immeuble ont été mises à jour",
  "Building's users": "Utilisateurs de l'immeuble",
  'Go to detail': 'Voir le détail',
  'Add user to building': "Ajouter un utilisateur à l'immeuble",
  'Add user': 'Ajouter un utilisateur',
  'Remove user': "Supprimer l'utilisateur",
  Remove: 'Supprimer',
  'User email': "E-mail de l'utilisateur",
  'The user has been added to the building': "L'utilisateur a été ajouté à l'immeuble",
  'The user has been removed from the building': "L'utilisateur a été supprimé de l'immeuble",
  'Remove user from building?': "Supprimer l'utilisateur de l'immeuble ?",
  'Remove user from company?': "Supprimer l'utilisateur de l'entreprise ?",
  Yes: 'Oui',
  No: 'Non',
  'My companies': 'Mes entreprises',
  Companies: 'Entreprises',
  'Edit company': "Modifier l'entreprise",
  'Create company': 'Créer une entreprise',
  'Manager email': 'E-mail du gestionnaire',
  'The company has been added to the building': "L'entreprise a été ajoutée à l'immeuble",
  'The company has been updated': "L'entreprise a été mise à jour",
  'The user has been added to the company': "L'utilisateur a été ajouté à l'entreprise",
  'The user has been removed from the company': "L'utilisateur a été supprimé de l'entreprise",
  'Add user to company': "Ajouter un utilisateur à l'entreprise",
  "Company's users": "Utilisateurs de l'entreprise",
  "Back to the building's companies": "Retour aux entreprises de l'immeuble",
  'My user roles in this company': "Mes rôles d'utilisateur dans cette entreprise",
  'Company detail': "Détail de l'entreprise",
  'New invitation': 'Nouvelle invitation',
  'The invitation has been sent': "L'invitation a été envoyée",
  Building: 'Immeuble',
  Host: 'Hôte',
  'You do not have invite permissions in any building':
    "Vous n'avez pas de permissions d'invitation dans aucun immeuble",
  "Guest's email": "E-mail de l'invité",
  Guest: 'Invité',
  'Invitation date': 'Heure',
  'As myself': 'En mon nom',
  'Invitation subject/reason': "Sujet/Raison de l'invitation",
  'Invitation duration': "Durée de l'invitation",
  'Modify meeting': 'Mettre à jour',
  '1 hour': '1 heure',
  '2 hours': '2 heures',
  '3 hours': '3 heures',
  '5 hours': '5 heures',
  '12 hours': '12 heures',
  Notes: 'Commentaires',
  'Allow access to the building for': 'Durée',
  'Create invitation': 'Créer une invitation',
  'Invitation detail': "Détail de l'invitation",
  Date: 'Date',
  hours: 'heures',
  'Access allowed for': 'Accès autorisé pour',
  'You are hosting': 'Vous avez invité',
  Confirmed: 'Confirmé',
  'Waiting confirmation': 'En attente de confirmation',
  Rejected: 'Rejeté',
  Cancelled: 'Annulé',
  Status: 'Statut',
  'Subject/Reason': 'Sujet/Raison',
  'Sent to': 'Envoyé à',
  'Sent date': "Date d'envoi",
  'I forgot my password': "J'ai oublié mon mot de passe",
  'Password recovery': 'Récupération de mot de passe',
  'Input your email and we will send you a link to restore your password':
    'Saisissez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe',
  Back: 'Retour',
  'Information was sent on how to restore your password':
    'Des informations sur la manière de réinitialiser votre mot de passe ont été envoyées',
  'Request password recovery': 'Demander la récupération du mot de passe',
  'Your password as been restored. You can now access with your new password':
    'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe',
  'Your email has been verified': 'Votre e-mail a été vérifié',
  'The email could not be verified': "L'e-mail n'a pas pu être vérifié",
  'Verify email': "Vérifier l'e-mail",
  PAST_DUE: 'Date dépassée',
  CANCELLED: 'Annulé',
  REJECTED: 'Refusé',
  CONFIRMED: 'Accepté',
  PENDING: 'En attente',
  Confirm: 'Confirmer',
  Reject: 'Rejeter',
  'The assistance to the invitation has been confirmed':
    "La participation à l'invitation a été confirmée",
  'Confirm assistance?': 'Confirmer la participation ?',
  'The invitation has been cancelled': "L'invitation a été annulée",
  'Cancel invitation?':
    "L'hôte sera informé que vous déclinez cette invitation. Confirmez-vous que vous déclinez ?",
  'The invitation has been rejected': "L'invitation a été rejetée",
  'Reject invitation?':
    "L'hôte sera informé que vous déclinez cette invitation. Confirmez-vous que vous déclinez ?",
  Required: 'Requis',
  'Invalid email': 'E-mail invalide',
  'Password confirm does not match': 'La confirmation du mot de passe ne correspond pas',
  'Select a building': 'Sélectionner un immeuble',
  Cellphone: 'Numéro de portable',
  Birthdate: 'Date de naissance',
  Habilitaçao: 'CNH',
  'RNE number': 'Numéro RNE',
  'ID Type': "Pièce d'identité officielle",
  'RG number': 'RG',
  RG: 'RG',
  RNE: 'RNE',
  Passport: 'Passeport',
  'CPF number': 'CPF',
  'Invalid ID number': "Numéro d'identification invalide",
  'Invalid CPF number': 'Numéro CPF invalide',
  Secretary: 'Secrétaire',
  'My secretaries': 'Définir les délégués',
  'New secretary': 'Nouvelle personne',
  'The user has been added as a secretary': "L'utilisateur a été ajouté comme secrétaire",
  'No results': 'Aucun résultat',
  'Search and select an user': 'Rechercher et sélectionner un utilisateur',
  'The user has been removed from your secretaries':
    "L'utilisateur a été retiré de vos secrétaires",
  'Remove user from your secretaries?': "Retirer l'utilisateur de vos secrétaires ?",
  '1. Select the building': "1. Sélectionnez l'immeuble",
  '2. Search a user and select from the list':
    '2. Recherchez un utilisateur et sélectionnez-le dans la liste',
  'Send invitation as yourself or acting as a secretary for another user':
    'Envoyer une invitation en votre nom ou en tant que secrétaire pour un autre utilisateur',
  'Send invitation as': "Envoyer l'invitation au nom de",
  'Building not found': 'Immeuble non trouvé',
  'Invalid token': 'Jeton invalide',
  Forbidden: 'Interdit',
  "There's no user registered with that email":
    "Aucun utilisateur n'est enregistré avec cet e-mail",
  'Email or password incorrect': 'E-mail ou mot de passe incorrect',
  'The building manager can not be removed':
    "Le gestionnaire de l'immeuble ne peut pas être supprimé",
  'Company not found': 'Entreprise non trouvée',
  'The company manager can not be removed':
    "Le gestionnaire de l'entreprise ne peut pas être supprimé",
  'You cannot invite in this building': 'Vous ne pouvez pas inviter dans cet immeuble',
  'The user cannot invite in this building': "L'utilisateur ne peut pas inviter dans cet immeuble",
  'Missing file': 'Fichier manquant',
  'You can not cancel a past invitation': 'Vous ne pouvez pas annuler une invitation passée',
  'The invitation can not be cancelled': "L'invitation ne peut pas être annulée",
  'You can not reject your own invitation': 'Vous ne pouvez pas rejeter votre propre invitation',
  'You can not reject a past invitation': 'Vous ne pouvez pas rejeter une invitation passée',
  'The invitation can not be rejected': "L'invitation ne peut pas être rejetée",
  'You can not confirm your own invitation': 'Vous ne pouvez pas confirmer votre propre invitation',
  'You can not confirm a past invitation': 'Vous ne pouvez pas confirmer une invitation passée',
  'The invitation can not be confirmed': "L'invitation ne peut pas être confirmée",
  'Invitation not found': 'Invitation non trouvée',
  "Can't create invitations on behalf user":
    "Impossible de créer des invitations au nom de l'utilisateur",
  "The user can't create invitations in this building":
    "L'utilisateur ne peut pas créer d'invitations dans cet immeuble",
  'You are not allowed to perform this action': "Vous n'êtes pas autorisé à effectuer cette action",
  'Multiple emails separated by comma': 'Plusieurs e-mails séparés par une virgule',
  'Sent invitations': 'Invitations envoyées',
  'Received invitations': 'Invitations',
  'Invitation data': "Données de l'invitation",
  'Account configuration': 'Paramètres',
  'My information': 'Mes informations',
  Account: 'Paramètres du compte',
  'My vehicle': 'Mon véhicule',
  'Your vehicle information was updated': 'Les informations de votre véhicule ont été mises à jour',
  Make: 'Marque',
  Model: 'Modèle',
  Color: 'Couleur',
  'License plate': "Plaque d'immatriculation",
  'The documents were uploaded': 'Les documents ont été téléchargés',
  'My documents': 'Mes documents',
  'ID Front': "Mettre à jour la photo du recto de la pièce d'identité",
  'ID Back': "Mettre à jour la photo du verso de la pièce d'identité",
  'Email or cellphone number': 'E-mail ou numéro de portable',
  'If using a cellphone number, it must be valid and include both country and area code. Ex (5511943210091)':
    "Si vous utilisez un numéro de portable, il doit être valide et inclure l'indicatif du pays et de la région. Ex (33612345678)",
  'Verify cellphone': 'Vérifier le portable',
  'Your cellphone has been verified': 'Votre portable a été vérifié',
  'The cellphone could not be verified': "Le portable n'a pas pu être vérifié",
  'A message was sent to your number with a verification code':
    'Un message avec un code de vérification a été envoyé à votre numéro',
  Skip: 'Passer',
  'Cellphone number': 'Numéro de portable',
  'Only numbers. Including country and area code':
    "Uniquement des chiffres. Incluant l'indicatif du pays et de la région",
  'Verify cellphone number': 'Vérifier le numéro de portable',
  'Your cellphone is already verified': 'Votre portable est déjà vérifié',
  'Request verification code': 'Demander un code de vérification',
  'Verification code': 'Code de vérification',
  Verify: 'Vérifier',
  'Invalid number': 'Numéro invalide',
  'Invalid email or cellphone': 'E-mail ou portable invalide',
  'Change email': "Changer d'e-mail",
  'Change phone': 'Changer de numéro de téléphone',
  'We have sent an email to your new email address. The change will be efective once you verify this new email':
    'Nous avons envoyé un e-mail à votre nouvelle adresse e-mail. Le changement sera effectif une fois que vous aurez vérifié ce nouvel e-mail',
  'Your phone number has been changed': 'Votre numéro de téléphone a été changé',
  'After you submit we will send a verification link to this new email address. The change will only be effective after you have verified this new email address.':
    "Vous recevrez un lien de vérification à l'adresse e-mail ci-dessous. Le changement d'e-mail ne prendra effet qu'après avoir suivi ce lien.",
  'Min 8 characters, one uppercase, one lowercase and one number':
    'Min 8 caractères, au moins une majuscule et un chiffre',
  'The token you are trying to use is not valid':
    "Le jeton que vous essayez d'utiliser n'est pas valide",
  Access: 'Accès',
  'There are not access codes available for the selected building':
    "Il n'y a pas de codes d'accès disponibles pour l'immeuble sélectionné",
  'Company role': "Rôle dans l'entreprise",
  Company: 'Entreprise',
  Accept: 'Accepter',
  'Terms and Conditions': "J'ai lu et j'accepte les termes et conditions",
  'Privacy policy': "J'ai lu et j'accepte la politique de confidentialité",
  'SMS consent':
    "J'accepte de recevoir des SMS automatiques de {{brand}} pour la vérification du compte et des raisons de sécurité",
  'SMS consent modal title': 'Pourquoi demandons-nous votre consentement SMS ?',
  'SMS consent modal body':
    'En cochant cette case, vous acceptez de recevoir des SMS automatisés de {{brand}} à des fins de vérification de compte et de sécurité. Des frais de messagerie et de données peuvent s’appliquer. Répondez STOP pour vous désabonner. Répondez HELP ou envoyez un e-mail à <2>{{helpEmail}}</2> pour obtenir de l’aide. Les Conditions et la Politique de confidentialité sont disponibles sur : <0>Conditions</0> et <1>Politique de confidentialité</1>.',
  Close: 'Fermer',
  'There was changes in our Terms of service and Privacy Policy. Please review them and make sure you accept them before you continue using our application.':
    'Les termes et conditions et la politique de confidentialité ont été mis à jour.',
  'Changes in Terms of service and Privacy Policy':
    'Changements dans les Termes de service et la Politique de confidentialité',
  'Delete my account': 'Supprimer mon compte',
  'Your account has been deleted.': 'Votre compte a été supprimé.',
  'Deleting your account is irreversible. All your data will be lost, including your personal information, invitations you sent and received, associations to buildings and secretaries.':
    'La suppression de votre compte est irréversible. Toutes vos données seront perdues, y compris vos informations personnelles, les invitations que vous avez envoyées et reçues, les associations aux immeubles et aux secrétaires.',
  'Input your password to delete the account':
    'Saisissez votre mot de passe pour supprimer le compte',
  'I understand. Delete my account': 'Je comprends. Supprimer mon compte',
  Invitations: 'Invitations',
  Invitation: 'Invitation',
  'The access code is being generated and will be visible here when the invitation date is due The access code is being generated and will be visible here when the invitation date is due':
    "Le code d'accès est en cours de génération et sera visible ici à la date d'échéance de l'invitation",
  "Host's email": "E-mail de l'hôte",
  "Host's cellphone": "Portable de l'hôte",
  'View invitation full detail': "Voir le détail complet de l'invitation",
  'The access code will be visible here once the invitation is confirmed':
    "Le code d'accès sera visible ici une fois l'invitation confirmée",
  'Download the app here': isUrclyrd
    ? "Téléchargez l'application Urclyrd ici"
    : "Téléchargez l'application Podesubir ici",
  'My Badge': 'Mon badge',
  Visitor: 'Visiteur',
  Meetings: 'Réunions',
  'New meeting': 'Nouvelle réunion',
  'Other guests': 'Autres invités',
  ACTIVE: 'en attente de confirmation',
  Invited: 'Invité',
  'Multiple emails/cellphones separated by comma': isUrclyrd
    ? 'Plusieurs e-mails, IDs ou portables séparés par une virgule'
    : 'Plusieurs e-mails, CPF ou portables séparés par une virgule',
  "Guest's contact": "Contact de l'invité",
  'Create meeting': 'Créer une réunion',
  Guests: 'Invités',
  'The meeting has been modified': 'La réunion a été modifiée',
  'Remove guest from the meeting?': "Retirer l'invité de la réunion ?",
  'Remove guest from the meeting': "Retirer l'invité de la réunion",
  'Cancel meeting?':
    "Le(s) invité(s) ser(a/ont) notifié(s) que vous annulez cette invitation. Confirmez-vous l'annulation ?",
  'The meeting has been cancelled': 'La réunion a été annulée',
  'Add guests to the meeting': 'Ajouter des invités à la réunion',
  Add: 'Ajouter',
  'For security reasons we encourage you to change your password.':
    'Pour des raisons de sécurité, nous vous encourageons à changer votre mot de passe.',
  None: 'Aucun',
  Floor: 'Étage',
  Room: 'Salle/Bureau',
  'Main company': 'Entreprise principale',
  'Allow access before meeting starts (minutes)':
    "Autoriser l'accès avant le début de la réunion (minutes)",
  'Meetings & Invitations': 'Réunions & invitations',
  'There are no more records': "Il n'y a plus d'enregistrements",
  'You were invited': 'Vous êtes invité',
  'Invited by': 'Invité par',
  'your best welcome': 'votre meilleur accueil',
  'Sign up': "S'inscrire",
  'Meeting date': 'Heure',
  terms: 'termes et conditions',
  privacypolicy: 'politique de confidentialité',
  'New email': 'Nouvel e-mail',
  'New cellphone number': 'Nouveau numéro de portable',
  Attention: 'Attention',
  'Date from': 'Date de début',
  'Date to': 'Date de fin',
  'Group data by': 'Regrouper les données par',
  Month: 'Mois',
  Week: 'Semaine',
  Day: 'Jour',
  Hour: 'Heure',
  Show: 'Afficher',
  'Show Filters': 'Afficher les filtres',
  'Visitors by building': 'Visiteurs par immeuble',
  'My stats': 'Mes rapports',
  Visitors: 'Visiteurs',
  'Visitors stay': 'Séjour des visiteurs',
  week: 'semaine',
  of: 'de',
  Stats: 'Rapports',
  'Profile Completed At': 'Profil complété',
  'Profile Approved At': 'Profil approuvé',
  'Profile Rejected At': 'Profil rejeté',
  'Average duration (minutes)': 'Durée moyenne (minutes)',
  'Average visits duration': 'Durée moyenne des visites',
  Stay: 'Séjour',
  'You need to be building manager to see reports':
    "Vous devez être gestionnaire d'immeuble pour voir les rapports",
  Sent: 'Envoyé',
  Received: 'Reçu',
  All: 'Tous',
  Pending: 'En attente',
  'Your profile has been rejected for the following reasons':
    'Votre profil a été rejeté pour les raisons suivantes',
  'Please complete all of your profile information in order to start using Podesubir':
    'Veuillez compléter toutes les informations de votre profil pour commencer à utiliser Podesubir',
  'Missing fields': 'Champs manquants / invalides',
  'Your profile is under review. You will receive a response within 24hs':
    "Votre profil est en cours d'examen. Vous recevrez une réponse dans les 24h",
  'Profile picture': 'Photo de profil',
  'ID number': "Numéro d'identification",
  'Documets ID Front picture': "Photo du recto de la pièce d'identité",
  'Documents ID Back picture': "Photo du verso de la pièce d'identité",
  'Click here to correct the relevant fields': 'Cliquez ici pour corriger les champs pertinents',
  'Email verification': "Vérification de l'e-mail",
  'Cellphone verification': 'Vérification du portable',
  'Basic information': 'Informations personnelles',
  'ID documents': "Pièces d'identité",
  Finalize: 'Finaliser',
  'We have sent you an email to your address': 'Nous vous avons envoyé un e-mail à votre adresse',
  'Please follow the instructions and click on continue':
    'Veuillez suivre les instructions et cliquer sur continuer',
  'If you did not received the email you can': "Si vous n'avez pas reçu l'e-mail, vous pouvez",
  'request a new verification email': 'demander un nouvel e-mail de vérification',
  'Alternatively you can': 'Alternativement, vous pouvez',
  'change your email address': 'changer votre adresse e-mail',
  Continue: 'Continuer',
  'A new email was sent to your address': 'Un nouvel e-mail a été envoyé à votre adresse',
  'Change email address': "Changer d'adresse e-mail",
  'Your email address was changed and a new verification email was sent':
    'Si vous avez fait une erreur ou souhaitez changer votre numéro de téléphone',
  'If you made a mistake or want to change your phone number':
    'Si vous avez fait une erreur ou souhaitez changer votre numéro de téléphone',
  'Change cellphone': 'Changer de portable',
  'We will now verify your cellphone number':
    'Nous allons maintenant vérifier votre numéro de portable',
  'We will send you a 4 digit verification code via SMS':
    'Nous vous enverrons un code de vérification à 4 chiffres par SMS',
  'I am ready, send me the verification code': 'Je suis prêt, envoyez-moi le code de vérification',
  'click here': 'cliquez ici',
  'Change cellphone number': 'Changer de numéro de portable',
  'An SMS was sent to your cellphone with the verification code':
    'Un SMS avec le code de vérification a été envoyé à votre portable',
  'Invalid code':
    "Le code saisi n'est pas valide ou a expiré. Vérifiez votre boîte de réception SMS et demandez un nouveau SMS si nécessaire",
  'Your cellphone number was changed and a new verification sms was sent':
    'Votre numéro de portable a été changé et un nouveau SMS de vérification a été envoyé',
  'Country of residence': 'Pays de résidence',
  'cpf is a required field': 'Requis',
  'Your face must be visible and centered in the picture frame':
    'Votre visage doit être visible et centré dans le cadre de la photo',
  'No other people should be visible in the picture':
    'Aucune autre personne ne doit être visible sur la photo',
  'Position your face within the crop area':
    'Positionnez votre visage à l’intérieur de la zone de recadrage',
  'The picture must match the picture in the ID documents from the next step':
    "La photo doit correspondre à la photo des pièces d'identité de l'étape suivante",
  'Take picture': 'Prendre une photo',
  NO_FACES: "Aucun visage n'a été détecté sur la photo. Lisez les instructions et réessayez",
  MULTIPLE_FACES:
    'Plusieurs visages ont été détectés sur la photo. Lisez les instructions et réessayez',
  'Confirm and save': 'Confirmer',
  'Make sure the ID pictures are clear and all the information can be seen':
    "Assurez-vous que les photos de la pièce d'identité sont claires et que toutes les informations sont visibles",
  'The face in the front of the ID must match your profile picture':
    "Le visage sur le recto de la pièce d'identité doit correspondre à votre photo de profil",
  'The information in the ID must match the information you provided in the previous step':
    "Les informations sur la pièce d'identité doivent correspondre aux informations que vous avez fournies à l'étape précédente",
  'ID picture front': "Photo du recto de la pièce d'identité",
  'ID picture back': "Photo du verso de la pièce d'identité",
  'You have completed all the registration steps':
    "Vous avez terminé toutes les étapes d'inscription",
  'If you would like to change any information you can go back to a previous step':
    'Si vous souhaitez modifier des informations, vous pouvez revenir à une étape précédente',
  'When you are ready, press finalize to complete the process':
    'Lorsque vous êtes prêt, appuyez sur finaliser pour terminer le processus',
  MISSING_REVIEW_CORRECTIONS:
    'Il y a encore des corrections de profil en attente avant que vous puissiez le soumettre',
  FACE_DOESNT_MATCH:
    "L'image fournie pour votre photo de profil ne correspond pas à l'image fournie comme recto de votre pièce d'identité",
  INFORMATION_DOESNT_MATCH:
    'Certaines des informations fournies dans "Informations personnelles" ne correspondent pas aux informations de votre pièce d\'identité.',
  'There was a validation error with the information provided':
    'Il y a eu une erreur de validation avec les informations fournies',
  'Go back to the previous steps and correct the information':
    'Revenez aux étapes précédentes et corrigez les informations',
  'If the information supplied is correct, click the following button to submit everything as is and a customer support representative will review your profile':
    'Si les informations fournies sont correctes, cliquez sur le bouton suivant pour tout soumettre tel quel et un représentant du service client examinera votre profil',
  'Submit my profile for review': 'Soumettre mon profil pour examen',
  'Your profile is under review by a customer service representative. We will notify you via email once the review is complete':
    "Votre profil est en cours d'examen par un représentant du service client. Nous vous informerons par e-mail une fois l'examen terminé",
  'Your profile has been rejected by a customer support representative':
    'Votre profil a été rejeté par un représentant du service client',
  'Please correct the following fields and re-submit your profile to be reviewed again':
    'Veuillez corriger les champs suivants et soumettre à nouveau votre profil pour examen',
  name: 'prénom',
  surname: 'nom de famille',
  company: 'entreprise',
  company_role: "rôle/poste dans l'entreprise",
  birthdate: 'date de naissance',
  id_type: "Type de pièce d'identité",
  id_number: "Numéro d'identification",
  cpf: 'Numéro CPF',
  profile_picture: 'Photo de profil',
  ID_FRONT: "Recto de la pièce d'identité",
  ID_BACK: "Verso de la pièce d'identité",
  'You have performed all the requested corrections. Submit your profile for review':
    'Vous avez effectué toutes les corrections demandées. Soumettez votre profil pour examen',
  'Your profile is now complete and your account verified. You can start using podesubir':
    'Votre profil est maintenant complet et votre compte est vérifié. Vous pouvez commencer à utiliser podesubir',
  true: 'Ne correspond pas aux informations sur la photo des documents',
  'Access code': "Code d'accès",
  employees: 'personnel',
  Filter: 'filtrer',
  Roles: 'Rôles',
  'Roles in the building': "Rôles dans l'immeuble",
  users: 'utilisateurs',
  Users: 'Utilisateurs',
  next: 'suivant',
  'your session expired. Please log in again':
    'Votre session a expiré pour des raisons de sécurité. Pour voir vos identifiants et réunions, veuillez vous reconnecter',
  'You are trying to log in from an unknown device. We have sent you an email with a verification code. Please input the code below to complete your login':
    'Vous essayez de vous connecter depuis un appareil inconnu. Nous vous avons envoyé un e-mail avec un code de vérification. Veuillez saisir le code ci-dessous pour finaliser votre connexion',
  'Go back': 'Retour',
  INVALID_AUTH: "Nom d'utilisateur ou mot de passe incorrect",
  EMAIL_ALREADY_VERIFIED: "L'adresse e-mail est déjà vérifiée",
  CELLPHONE_ALREADY_VERIFIED: 'Le numéro de portable est déjà vérifié',
  INVALID_TOKEN: 'Le jeton est invalide',
  FORBIDDEN: "Vous n'êtes pas autorisé à effectuer cette action",
  USER_NOT_FOUND: 'Utilisateur non trouvé',
  NOT_FOUND: 'Non trouvé',
  MEETING_IS_PAST: "La réunion est passée. L'action ne peut pas être effectuée",
  MISSING_INVITATIONS_PERMISSIONS: "Permissions d'invitation manquantes pour cet immeuble",
  USER_IS_NOT_GUEST:
    "Vous n'êtes pas un invité à cette invitation. L'action ne peut pas être effectuée",
  CONFIRMATION_FAILED: "L'invitation n'a pas pu être confirmée",
  REJECTION_FAILED: "L'invitation n'a pas pu être rejetée",
  CANCELLATION_FAILED: "L'invitation n'a pas pu être annulée",
  EMAIL_ALREADY_IN_USE: "L'adresse e-mail que vous avez saisie est déjà utilisée",
  CELLPHONE_ALREADY_IN_USE: 'Le portable que vous avez saisi est déjà utilisé',
  CELLPHONE_VERIFICATION_COOLDOWN:
    'Veuillez patienter un instant avant de demander un nouveau code',
  CELLPHONE_VERIFICATION_BLOCKED: 'Trop de tentatives. Veuillez réessayer plus tard',
  DUPLICATE_ENTRY: 'Cette valeur est déjà utilisée',
  GENERIC_ERROR: 'Une erreur est survenue, veuillez réessayer',
  PROFILE_NOT_APPROVED: "Vous n'êtes pas autorisé à effectuer cette action",
  VALIDATION_ERROR: 'Erreur de validation',
  'The cellphone entered is already in use': 'Le portable saisi est déjà utilisé',
  'The email entered is already in use': "L'e-mail saisi est déjà utilisé",
  Registration: 'Inscription',
  Domain: 'Domaine',
  'Total users': 'Total des utilisateurs',
  previous: 'précédent',
  'Total approved': 'Total approuvé',
  '% approved': '% approuvé',
  'Users growth': 'Croissance des utilisateurs',
  'Approved growth': 'Croissance des approbations',
  'Compare data to previous': 'Comparer les données aux précédentes',
  Trimester: 'Trimestre',
  'Access list': "Liste d'accès",
  'Security staff': 'Personnel de sécurité',
  'Access date': "Date d'accès",
  'PS user profile approved': 'Profil utilisateur PS approuvé',
  'PS user profile complete': 'Profil utilisateur PS complet',
  'PS user email': 'E-mail utilisateur PS',
  'Has invitation in PS': 'A une invitation dans PS',
  'Download CSV': 'Télécharger le CSV',
  'Card code': 'Code de la carte',
  'Used QR': 'QR utilisé',
  'Only with corresponding invitation': 'Uniquement avec une invitation correspondante',
  'Only with corresponding user in PS': 'Uniquement avec un utilisateur correspondant dans PS',
  'Only with profile completed in PS': 'Uniquement avec un profil complété dans PS',
  'Only with profile approved in PS': 'Uniquement avec un profil approuvé dans PS',
  "Request the guest to announce it's arrival to be allowed in":
    "Demander à l'invité d'annoncer son arrivée pour être autorisé à entrer",
  'Your guest arrived to the meeting. Click here to see more':
    'Votre invité est arrivé à la réunion. Cliquez ici pour en savoir plus',
  'Your have a new invite notification':
    'Vous avez été invité à une réunion par {{name}} {{surname}}',
  'The host delayed your entry to the meeting. Click here to see more':
    "L'hôte a retardé votre entrée à la réunion. Cliquez ici pour en savoir plus",
  'The host allowed your entry to the meeting. Click here to see more':
    "L'hôte a autorisé votre entrée à la réunion. Cliquez ici pour en savoir plus",
  'The waiting time is over. We have reminded the host about your arrival':
    "Le temps d'attente est terminé. Nous avons rappelé à l'hôte votre arrivée",
  'Your host requested for you to wait {{minutes}} minutes':
    "Votre hôte vous a demandé d'attendre {{minutes}} minutes",
  'When your access is authorized you will be able to access directly with the QR code that will appear here':
    'Lorsque votre accès sera autorisé, vous pourrez y accéder directement avec le code QR qui apparaîtra ici',
  Close: 'Fermer',
  'Your arrival has been notified': 'Votre arrivée a été notifiée',
  'Announce arrival': "Annoncer l'arrivée",
  'Allow access': "Autoriser l'accès",
  'Wait 5 minutes': 'Attendre 5 minutes',
  'Wait 10 minutes': 'Attendre 10 minutes',
  'Your guest arrived': 'Votre invité est arrivé',
  'The guest has been allowed access': "L'invité a été autorisé à accéder",
  'Allow access?': "Autoriser l'accès ?",
  'The guest has been notified of the delay': "L'invité a été informé du retard",
  'Delay the access?': "Retarder l'accès ?",
  'agenda belongs to': "l'ordre du jour appartient à",
  'You must not be wearing a facemask or anything that partially covers your face':
    'Vous ne devez pas porter de masque facial ni rien qui couvre partiellement votre visage',
  'For a better experience use Google Chrome or Microsoft Edge':
    'Pour une meilleure expérience, utilisez Google Chrome ou Microsoft Edge',
  'New picture': 'Nouvelle photo',
  'Access allowed by guards': 'Accès autorisé par les gardes',
  Search: 'Rechercher',
  'Security guard': 'Agent de sécurité',
  'guard.access.ENTRY': 'ENTRÉE AUTORISÉE',
  'guard.access.EXIT': 'SORTIE AUTORISÉE',
  'guard.access.DENY_ENTRY': 'ENTRÉE REFUSÉE',
  Event: 'événement',
  'who.visited.who': 'qui a visité qui',
  'Employees per company': 'Employés par entreprise',
  Local: 'local',
  'Host name': "Nom de l'hôte",
  'Host surname': "Nom de famille de l'hôte",
  'Host email': "E-mail de l'hôte",
  'Guest name': "Nom de l'invité",
  'Guest surname': "Nom de famille de l'invité",
  'Guest email': "E-mail de l'invité",
  'Guest phone': "Téléphone de l'invité",
  'Guest document': "Document de l'invité",
  'Guest CPF': "CPF de l'invité",
  'Host company': "Entreprise de l'hôte",
  'Guest company': "Entreprise de l'invité",
  Export: 'exporter',
  'Order:': 'Commande :',
  'Badge number:': 'Numéro de badge :',
  'Guest badge number': "Numéro de badge de l'invité",
  'Date of visit': 'Date de la visite',
  'Start time': 'Heure de début',
  'Finish time': 'Heure de fin',
  'Document number': 'Numéro de document',
  'Document type': 'Type de document',
  'date-format': 'DD/MM/YYYY',
  'time-format': 'HH:mm',
  'datetime-format': 'DD/MM/YYYY HH:mm',
  'date-ampm': 'false',
  Return: 'Retour',
  'Are you sure about that?': 'Êtes-vous sûr de cela ?',
  'Access code linked to another user': "Code d'accès lié à un autre utilisateur",
  'Associate with new user': 'Associer à un nouvel utilisateur',
  'Unlinked user': 'Utilisateur non lié',
  Copy: 'Copier',
  'Taking photo': 'Prise de photo en cours',
  'Send image': "Envoyer l'image",
  'Max date Error': 'Période maximale de 3 mois',
  'Min date Error': 'Ne peut pas être antérieure à la date de début',
  CELLPHONE_VERIFICATION_COOLDOWN: 'Veuillez patienter un peu avant de réessayer',
  CELLPHONE_VERIFICATION_BLOCKED:
    "Nous avons détecté des tentatives de vérification répétées et bloqué l'envoi de SMS par sécurité. Veuillez contacter le support pour continuer",
  'You can request a new code in {{seconds}}s':
    'Vous pourrez demander un nouveau code dans {{seconds}}s',
  'For your security, SMS sending was temporarily blocked due to repeated attempts':
    "Pour votre sécurité, l'envoi de SMS a été temporairement bloqué en raison de tentatives répétées",
  'Please contact our support team via WhatsApp or phone to continue {{phone}}':
    'Veuillez contacter notre support par WhatsApp ou téléphone pour continuer : {{phone}}',
  'Contact support on WhatsApp': 'Contacter le support sur WhatsApp',
  'mcp.consent.title': '{{client}} souhaite accéder à votre compte {{brand}}',
  'mcp.consent.domainLabel': "Domaine de l'application",
  'mcp.consent.unverifiedBadge': 'Non vérifié',
  'mcp.consent.unverifiedHint':
    "L'application a indiqué ce domaine elle-même. Il n'a pas été vérifié.",
  'mcp.consent.accountLabel': 'Compte utilisé',
  'mcp.consent.switchAccount': "Ce n'est pas vous ? Changer de compte",
  'mcp.consent.permissionsLabel': 'Autorisations que vous accordez',
  'mcp.scope.invitations:read.label': 'Voir les invitations que vous avez reçues',
  'mcp.scope.meetings:read.label':
    "Voir les réunions que vous avez créées ou gérez en tant qu'assistant(e), invités compris",
  'mcp.scope.invitations:write.label': 'Confirmer ou refuser des invitations en votre nom',
  'mcp.scope.meetings:write.label':
    'Créer des réunions et inviter des personnes ; modifier et annuler vos réunions et changer leurs invités',
  'mcp.consent.writeBadge': 'Modifie des données',
  'mcp.consent.meetingsWriteNotice':
    "L'application pourra créer des réunions et inviter des personnes, ainsi que modifier et annuler des réunions. Les invités seront prévenus par e-mail et par notification push.",
  'mcp.consent.selectAtLeastOne': 'Cochez au moins une autorisation pour continuer.',
  'mcp.consent.allow': 'Autoriser',
  'mcp.consent.deny': 'Refuser',
  'mcp.consent.sending': 'Envoi en cours…',
  'mcp.consent.actionError': "Impossible de terminer l'opération. Réessayez.",
  'mcp.consent.loading': 'Chargement de la demande…',
  'mcp.consent.expired':
    "Cette demande a expiré. Retournez dans l'application et essayez de vous reconnecter.",
  'mcp.consent.loadError':
    'Impossible de charger la demande. Vérifiez votre connexion et réessayez.',
  'mcp.consent.tryAgain': 'Réessayer',
  'mcp.consent.goToBrand': 'Aller sur {{brand}}',
  'mcp.consent.profileNotApproved':
    "Votre inscription est encore en cours d'examen. Une fois approuvée, retournez dans l'application et reconnectez-vous.",
  'mcp.consent.accountUnavailable':
    "Ce compte ne peut pas connecter d'applications pour le moment. Changez de compte ou refusez la demande pour retourner dans l'application.",
  'mcp.consent.alreadyDecided':
    "Cette demande a déjà reçu une réponse. Retournez dans l'application.",
  'mcp.consent.seeConnectedApps': 'Voir les applications connectées',
  'mcp.connectedApps.title': 'Applications connectées',
  'mcp.connectedApps.intro':
    'Ces applications peuvent accéder à votre compte {{brand}}. Vous pouvez révoquer leur accès à tout moment.',
  'mcp.connectedApps.permissionsLabel': 'Autorisations accordées',
  'mcp.connectedApps.connectedOn': 'Connecté le {{date}}',
  'mcp.connectedApps.lastUsed': 'Dernière utilisation : {{date}}',
  'mcp.connectedApps.neverUsed': 'Jamais utilisé',
  'mcp.connectedApps.revoke': "Révoquer l'accès",
  'mcp.connectedApps.revokeConfirm':
    "Révoquer l'accès de {{client}} ({{domain}}) ? Il cessera de fonctionner immédiatement et, pour l'utiliser à nouveau, vous devrez le reconnecter.",
  'mcp.connectedApps.revoked': 'Accès révoqué.',
  'mcp.connectedApps.revokeError': "Impossible de révoquer l'accès. Réessayez.",
  'mcp.connectedApps.loadError': 'Impossible de charger vos applications connectées.',
  'mcp.connectedApps.empty':
    "Aucune application connectée pour l'instant. Quand vous en connecterez une, elle apparaîtra ici.",
};
